const routes = {
  home: "/",
  signIn: "/sign-in",
  signInRole: "/sign-in/:role",
  signUp: "/sign-up",
  signUpVendor: "/sign-up/vendor",
  signUpAgency: "/sign-up/agency",
  signUpAgencyRnt: "/sign-up/agency/rnt",
  signUpAgencyData: "/sign-up/agency/data",
  signUpAgencyDocuments: "/sign-up/agency/documents",
  signUpAgencyPending: "/sign-up/agency/pending",
  signUpAgencySuccess: "/sign-up/agency/success",
  tickets: "/tickets",
  quotes: "/quotes",
  reports: "/reports",
  users: "/users",

  agency: "/agency",
  agencyDashboard: "/agency/dashboard",
  agencyExperienceCreation: "/agency/experience-creation",
  agencyExperienceCreationId: "/agency/experience-creation/:id",
  agencyExperienceCreationPurchaseSummary:
    "/agency/experience-creation/:id/purchase-summary",
  agencyPaymentManagement: "/agency/payment-management",
  agencyPaymentManagementPricing: "/agency/payment-management/:id/pricing",
  agencyPaymentManagementInstallments:
    "/agency/payment-management/:id/installments",
  agencyPaymentManagementServices: "/agency/payment-management/:id/services",
  agencyPaymentManagementServicesService:
    "/agency/payment-management/:id/services/:service",
  agencyPaymentManagementPassengersInstallments:
    "/agency/payment-management/:id/passengers-installments",
  agencyTripsAndPassengers: "/agency/trips-and-passengers",
  agencyProfile: "/agency/profile",
  agencyProfileBalance: "/agency/profile/balance",
  agencyCommissions: "/agency/commissions",
  agencyProfileDocuments: "/agency/profile/documents",
  agencyQuotations: "/agency/quotations",
  agencyTemplates: "/agency/templates",
  agencyTemplatesBooking: "/agency/templates/:id/booking",

  quotations: "/my-quotations",
  trips: "/trips",
  admin: "/admin",
  tour: "/tour/:id",
  tourSeatSelection: "/tour/:id/seat-selection",
  tourPurchaseSummary: "/tour/:id/purchase-summary",

  profile: "/profile",
  profileBalance: "/profile/balance",
  profileDocuments: "/profile/documents",

  paymentResult: "/payment/result",

  experienceCreation: "/experience-creation",
  experienceCreationId: "/experience-creation/:id",
  experienceCreationPurchaseSummary:
    "/experience-creation/:id/purchase-summary",
  experienceCreationComplements: "/experience-creation/:id/complements",

  tripsInstallments: "/trips/:id/installments",

  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",

  tripsConfirmation: "/trips/:id/confirmation",
  docsTermsAndConditions: "/docs/terms-and-conditions",
  docsServiceSummary: "/docs/service-summary",

  survey: "/survey",

  transfer: "/transfer",
  transferTransportSelection: "/transfer/transport-selection",
  transferScheduleSelection: "/transfer/schedule-selection",
  transferBookingConfirmation: "/transfer/booking-confirmation",
  transferPaymentConfirmation: "/transfer/payment-confirmation",
  transferBookingLookup: "/transfer/booking-lookup",
  transferBookingDetails: "/transfer/booking-details",
};

export default routes;
